import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    padding-bottom: ", ";\n    padding-right: ", ";\n        width: ", ";\n    \n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
import List from './List';
var GridListItem = styled(List).withConfig({
  displayName: "GridListItem",
  componentId: "oyuu8c-0"
})(["padding-bottom:", ";padding-right:", ";width:100%;", " ", ""], rem(16), rem(16), media.sm(_templateObject(), rem(24), rem(24), function (_ref) {
  var rowAmount = _ref.rowAmount;
  return 100 / rowAmount + "%";
}), function (_ref2) {
  var rowAmount = _ref2.rowAmount;
  return rowAmount && css(["&:nth-child(", "n){padding-right:0;}"], rowAmount);
});
export default GridListItem;